module.exports = __webpack_public_path__ + "img/fwf_farmerstoken.6bd52ab.png";